module.exports = __webpack_public_path__ + "static/Design-dbdec45b35ce70e9938bc5a03856469e.png";